import React, { useMemo, useState, useEffect } from "react"

//import components
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
} from "reactstrap"
import {
  FaEdit,
  FaStreetView,
  FaTelegramPlane,
  FaRegPaperPlane,
} from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchPvsBrand } from "../../../redux/actions/pvs"

const PvsBrand = () => {
  document.title = "PVS Brand List | PULA"

  const history = useNavigate()
  const dispatch = useDispatch()

  const pvsState = useSelector(state => state.pvs)
  const fetchPvsBrandState = useSelector(
    state => state.screens.pvs.fetchPvsBrand
  )

  const [brandData, setBrandData] = useState([])
  const columns = useMemo(
    () => [
      {
        header: "Brand Name",
        accessorKey: "brand_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Categories",
        accessorKey: "categories_label",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Subcategories",
        accessorKey: "subcategories_label",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Keywords",
        accessorKey: "keywords_label",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Created At",
        accessorKey: "created_modified_at",
        enableColumnFilter: false,
        enableSorting: true,
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchPvsBrand())
  }, [dispatch])

  useEffect(() => {
    if (pvsState && pvsState && Array.isArray(pvsState.brandList)) {
      setBrandData(pvsState.brandList)
    }
  }, [pvsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">Brand Wise List</h4>
          </div>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={brandData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
          noDataMessage={fetchPvsBrandState.message}
        />
      </div>
    </div>
  )
}

export default PvsBrand
